/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { UpdateScholarshipGeneralStatusRequestViewModel } from "../types/UpdateScholarshipGeneralStatusRequestViewModel.ts";
import { eScholarshipTypeStudentFileApprovalStatusSchema } from "./eScholarshipTypeStudentFileApprovalStatusSchema.ts";

export const updateScholarshipGeneralStatusRequestViewModelSchema = z.object({
  courseFinancialPersonId: z.optional(
    z
      .number()
      .int()
      .describe(
        "ID do plano financeiro do aluno que terá o status geral alterado. Obrigatório.",
      ),
  ),
  newGeneralStatus: z.optional(
    z
      .lazy(() => eScholarshipTypeStudentFileApprovalStatusSchema)
      .describe(
        "0 = PendingAnswerFromTeam | 1 = Approved | 2 = Rejected | 3 = ApprovedTemporary | ",
      ),
  ),
}) as unknown as ToZod<UpdateScholarshipGeneralStatusRequestViewModel>;
